// Verbatim Section 16.8a statements from QME - Tool's gripModel.
export const GRIP_PAIN_NOTE =
  'Grip strength testing was limited by pain; per Section 16.8a, grip strength is not a valid parameter for impairment rating.';
export const GRIP_EFFORT_NOTE =
  'Grip strength testing was limited by effort rather than pain; per Section 16.8a, grip strength is not a valid parameter for impairment rating.';
